export default {"src":"/_next/static/media/music-icon.c5b172eb.svg","height":120,"width":160,"blurWidth":0,"blurHeight":0};